module.exports = __webpack_public_path__ + "img/20190529143115微信截图_20190529143515.52ad0a35.png";